import React from 'react';
import PropTypes from 'prop-types';

export default class RadioGroup extends React.PureComponent {
    static propTypes = {
        /** Expected to be one or more Radios */
        children: PropTypes.node.isRequired,

        /** The name given to each Radio */
        name: PropTypes.string.isRequired,

        /** The value of the selected item in the group */
        value: PropTypes.string,

        /** Change handler passed to each radio */
        onChange: PropTypes.func,

        /** Makes the group required */
        isRequired: PropTypes.bool,

        /** Makes all the Radios in the group disabled */
        isDisabled: PropTypes.bool
    };

    static defaultProps = {
        value: undefined,
        onChange: undefined,
        isRequired: false,
        isDisabled: false
    };

    render() {
        const {
            children,
            value,
            name,
            isRequired,
            isDisabled,
            onChange
        } = this.props;

        return (
            <React.Fragment>
                {React.Children.map(children, (child) => {
                    return React.cloneElement(child, {
                        isChecked: value ? value === child.props.value : null,
                        name,
                        isRequired,
                        isDisabled: isDisabled || child.props.isDisabled,
                        onChange
                    })
                })}
            </React.Fragment>
        );
    }
}